import script from "./CertificateEditModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CertificateEditModal.vue?vue&type=script&setup=true&lang=js"

import "./CertificateEditModal.vue?vue&type=style&index=0&id=41d68e4a&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41d68e4a"]])

export default __exports__